const errorMessage = document.getElementById("errorMessage");

console.log(errorMessage);
if (errorMessage) {
    const closeBtn = document.getElementById("errorMessageCloseBtn");
    const forceShow = errorMessage.dataset.forceShow === "true";
    closeBtn.addEventListener("click", () => {
        errorMessage.classList.remove("show");
        document.body.classList.remove("overflow-hidden");
        sessionStorage["errorMessageClosed"] = true;
    });

    const displayErrorMessage = () => {
        console.log('in displayErrorMessage');
        const storage = sessionStorage.errorMessageClosed;
        if (!storage || forceShow) {
            errorMessage.classList.add("show");
            document.body.classList.add("overflow-hidden");
        }
    };

    if (document.body.classList.contains('document-home') && !document.body.classList.contains('introDone')) {
        window.addEventListener("introDone", displayErrorMessage);
    } else {
        window.addEventListener("load", displayErrorMessage);
    }

}
